import { normalize, denormalize, schema } from 'normalizr';
import Vue from 'Vue';
import { SourceService } from '@/services/pa/source.service';
import store from '@/store';
import {
    ERROR_HANDLE_ERROR,
    ERROR_CLEAR_ERROR
} from '../error/actions.type';

import {
    SOURCE_GET,
    SOURCE_GET_SETTING,
    SOURCE_FILTER_ADD,
    SOURCE_FILTER_REMOVE,
    SOURCE_FILTER_SAVE,
    SOURCE_FILTER_REQUESTAPPROVAL,
    SOURCE_FILTER_APPROVE,
    SOURCE_FILTER_DENY,
    SOURCE_FILTER_PUBLISH,
    SOURCE_PHARMACY_ADD,
    SOURCE_PHARMACY_REMOVE,
    SOURCE_PHARMACY_SAVE,
    SOURCE_PHARMACY_REQUESTAPPROVAL,
    SOURCE_PHARMACY_APPROVE,
    SOURCE_PHARMACY_PUBLISH,
    SOURCE_PHARMACY_CANCEL,
    SOURCE_SEARCH,
    SOURCE_FILTER_CANCEL
} from './actions.type';
import {
    SET_SOURCE_BUSY,
    SET_SOURCE_SEARCH_BUSY,
    SET_SOURCE_GET,
    SET_SOURCE_FILTER_REMOVE,
    SET_SOURCE_FILTER_SAVE,
    SET_SOURCE_PHARMACY_REMOVE,
    SET_SOURCE_PHARMACY_SAVE,
    SET_SOURCE_SEARCH,
    SET_CURRENT_SETTING
} from './mutations.type';

const initialState = {
    searchResults: {
        total: 0, records: []
    },
    isSearchBusy: false,
    isBusy: false,
    currentSource: {},
    currentSourceEntities: {},
    currentSetting: {}
};

const filters = new schema.Entity('filters', {}, { idAttribute: 'setting_key_id' });
const fileSourceSettings = new schema.Entity('file_source_settings', {}, { idAttribute: 'setting_key_id' });
const sourcesSchema = { filter_settings: [filters], file_source_settings: [fileSourceSettings] };

const record = new schema.Entity('records', {}, { idAttribute: 'source_name' });
const searchResultsSchema = { records: [record] };

export const state = Object.assign({}, initialState);

export const actions = {
    [SOURCE_SEARCH](context) {
        context.commit(SET_SOURCE_SEARCH_BUSY, true);
        return SourceService.query()
            .then((data) => {
                context.commit(SET_SOURCE_SEARCH_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_SEARCH, data);
                }
                return data;
            },
            (err) => {
                context.commit(SET_SOURCE_SEARCH_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
            });
    },
    [SOURCE_GET](context, filterCriteria) {
        context.commit(SET_SOURCE_SEARCH_BUSY, true);
        context.commit(SET_SOURCE_GET, {});
        return SourceService.get(filterCriteria.source, filterCriteria.filter)
            .then((data) => {
                context.commit(SET_SOURCE_SEARCH_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_GET, data);
                }
                return data;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
            });
    },
    [SOURCE_GET_SETTING](context, setting) {
        context.commit(SET_SOURCE_SEARCH_BUSY, true);
        context.commit(SET_CURRENT_SETTING, {});
        return SourceService.getSettingByKey(setting, setting.request_active)
            .then((data) => {
                context.commit(SET_SOURCE_SEARCH_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_CURRENT_SETTING, data);
                }
                return data;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
            });
    },
    [SOURCE_FILTER_ADD](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.add(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_FILTER_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_FILTER_SAVE](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.save(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_FILTER_SAVE, data);
                    return true;
                }
                return data;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_FILTER_REMOVE](context, setting) {
        context.commit(SET_SOURCE_FILTER_REMOVE, setting);
    },
    [SOURCE_FILTER_REQUESTAPPROVAL](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.requestApproval(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_FILTER_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_FILTER_APPROVE](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.approve(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_FILTER_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_FILTER_DENY](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.deny(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_FILTER_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_FILTER_CANCEL](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.cancelUpdate(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_FILTER_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_FILTER_PUBLISH](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.publish(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_FILTER_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_PHARMACY_ADD](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.add(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_PHARMACY_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_PHARMACY_SAVE](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.save(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_PHARMACY_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_PHARMACY_REMOVE](context, filter) {
        context.commit(SET_SOURCE_PHARMACY_REMOVE, filter);
    },
    [SOURCE_PHARMACY_REQUESTAPPROVAL](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.requestApproval(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_PHARMACY_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_PHARMACY_APPROVE](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.approve(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_PHARMACY_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_PHARMACY_PUBLISH](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.publish(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_PHARMACY_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    },
    [SOURCE_PHARMACY_CANCEL](context, setting) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_SOURCE_BUSY, true);
        return SourceService.cancelUpdate(setting)
            .then((data) => {
                context.commit(SET_SOURCE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_SOURCE_PHARMACY_SAVE, data);
                }
                return true;
            },
            (err) => {
                context.commit(SET_SOURCE_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
                return false;
            });
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
    [SET_SOURCE_SEARCH](state, results) {
        const normalizedResults = normalize(results, searchResultsSchema);

        state.searchResults = results;
        state.searchResultsEntities = normalizedResults.entities;
    },
    [SET_SOURCE_BUSY](state, isBusy) {
        state.isBusy = isBusy;
    },
    [SET_SOURCE_SEARCH_BUSY](state, isBusy) {
        state.isSearchBusy = isBusy;
    },
    [SET_SOURCE_GET](state, source) {
        const normalizedSource = normalize(source, sourcesSchema);
        state.currentSource = normalizedSource.result;
        state.currentSourceEntities = normalizedSource.entities;
    },
    [SET_CURRENT_SETTING](state, setting) {
        state.currentSetting = setting;
    },
    [SET_SOURCE_FILTER_REMOVE](state, filter) {
        const index = state.currentSource.filters.indexOf(filter);
        if (index !== -1) {
            state.currentSource.filters.splice(index, 1);
        }
    },
    [SET_SOURCE_FILTER_SAVE](state, filter) {
        if (!state.currentSourceEntities.filters[filter.setting_key_id]) {
            state.currentSource.filter_settings.push(filter.setting_key_id);
        }

        Vue.set(state.currentSourceEntities.filters, filter.setting_key_id, Object.assign({}, filter));
        // Force vue state to update getters
        state.currentSourceEntities.filters = {...state.currentSourceEntities.filters};
    },
    [SET_SOURCE_PHARMACY_REMOVE](state, pharmacy) {
        const index = state.currentSource.file_source_settings.indexOf(pharmacy);
        if (index !== -1) {
            state.currentSource.file_source_settings.splice(index, 1);
        }
    },
    [SET_SOURCE_PHARMACY_SAVE](state, pharmacy) {
        if (!state.currentSourceEntities.file_source_settings[pharmacy.setting_key_id]) {
            state.currentSource.file_source_settings.push(pharmacy.setting_key_id);
        }
        Vue.set(state.currentSourceEntities.file_source_settings, pharmacy.setting_key_id, Object.assign({}, pharmacy));
        // Force vue state to update getters
        state.currentSourceEntities.file_source_settings = {...state.currentSourceEntities.file_source_settings};
    }
};

const getters = {
    sourceSearchResults: state => state.searchResults,
    currentSource: state => {
        return denormalize(state.currentSource, sourcesSchema, state.currentSourceEntities);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/copay-epa-source/copayepasource.module.js